import { SocketClient } from "cbcore-ts"
import {
    CALL,
    nil,
    UIButton,
    UIColor,
    UIRoute,
    UITextField,
    UITextView,
    UIView,
    UIViewController,
    YES
} from "uicore-ts"
import { CBButton } from "./Custom components/CBButton"
import { CBButtonGroup } from "./Custom components/CBButtonGroup"
import { CBDialogViewShower } from "./Custom components/CBDialogViewShower"
import { ProcurerMainViewController } from "./ProcurerMainViewController"


export class RegisterUserViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        undefined,
        UITextView.type.header2
    ).configuredWithObject({
        text: "Register user",
        hoverText: "",
        backgroundColor: UIColor.transparentColor
    }).addedAsSubviewToView(this.view)
    
    usernameTextField = new UITextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Email",
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.passwordTextField.focus()
            }
        }
        
    })
    passwordTextField = new UITextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Password",
        viewHTMLElement: {
            setAttribute: CALL("type", "password")
        },
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.passwordTextFieldAgain.focus()
            }
        }
    })
    passwordTextFieldAgain = new UITextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Repeat password",
        viewHTMLElement: {
            setAttribute: CALL("type", "password")
        },
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.registerButton.sendControlEventForKey(UIButton.controlEvent.EnterDown, nil)
            }
        }
    })
    
    procurerTypeButton = new CBButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Hankija" },
        selected: YES
    })
    offererTypeButton = new CBButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Pakkuja" }
    })
    userTypeButtonGroup = new CBButtonGroup({
        "procurer": this.procurerTypeButton,
        "offerer": this.offererTypeButton
    })
    
    registerButton = new CBButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Register"
        },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    
                    if (this.passwordTextField.text != this.passwordTextFieldAgain.text) {
                        
                        CBDialogViewShower.alert("Passwords must match")
                        
                        return
                        
                    }
                    
                    
                    const result = (await SocketClient.RegisterNewUser({
                        email: this.usernameTextField.text,
                        password: this.passwordTextField.text,
                        type: (this.userTypeButtonGroup.value ?? "procurer") as "procurer" | "offerer"
                    })).result
                    
                    if (result.accepted) {
                        
                        // CBCore.sharedInstance.userProfile = result.userProfile
                        
                        const loginResult = await fetch("/auth/login", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                email: this.usernameTextField.text,
                                password: this.passwordTextField.text
                            })
                        })
                        
                        console.log(loginResult)
                        alert("Result " + loginResult.ok)
                        
                        UIRoute.currentRoute
                            .routeByRemovingComponentNamed(RegisterUserViewController.routeComponentName)
                            .routeWithViewControllerComponent(ProcurerMainViewController, {})
                            .apply()
                        
                        
                    }
                    
                    
                    
                }
            }
        }
    })
    
    bottomView = new UIView().addedAsSubviewToView(this.view)
    
    constructor(view: UIView) {
        
        super(view)
        
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: UIColor.whiteColor,
            hoverText: ""
        })
        
    }
    
    
    static override readonly routeComponentName = "register"
    
    static override readonly ParameterIdentifierName = {}
    
    override async viewDidAppear() {
        
        await super.viewDidAppear()
        
        this.usernameTextField.focus()
        
        
    }
    
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        const inquiryComponent = route.componentWithName(RegisterUserViewController.routeComponentName)
        
    }
    
    
    override updateViewConstraints() {
        
        super.updateViewConstraints()
        
    }
    
    
    override updateViewStyles() {
        
        super.updateViewStyles()
        
    }
    
    
    override viewDidLayoutSubviews() {
        
        super.viewDidLayoutSubviews()
        
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        
        
        this.titleLabel.frame.rectangleForNextRow(padding*2)
            .distributeViewsEquallyAlongWidth([this.usernameTextField], padding)
            .rectangleForNextRow(padding)
            .distributeViewsEquallyAlongWidth([this.passwordTextField], padding)
            .rectangleForNextRow(padding)
            .distributeViewsEquallyAlongWidth([this.passwordTextFieldAgain], padding)
            .rectangleForNextRow(padding, labelHeight * 2)
            .distributeViewsEquallyAlongWidth([this.registerButton], padding)
            .rectangleForNextRow(padding)
            .distributeViewsEquallyAlongWidth([this.bottomView], padding)
        
        
        
    }
}
